module.exports = __webpack_public_path__ + "static/media/FIU_Online.1b264c68.svg";